<app-shared-loading *ngIf="loading"></app-shared-loading>
<div class="instructions-button-container">
  <br>
  <button mat-flat-button class="paymentInfo" (click)="generatePdfInstructions()">
    {{ 'download-payment-instructions-button' | translation | async }}
  </button>
  <br>
</div>

<div  id="emptyContainer" class="emptyContainer"></div>

<div id="content" class="instructions-container-pdf" #content>
  <div class="instruccion-info">
    <p>{{ 'agreement-name-and-code-label' | translation | async }}{{networkName}}: {{agreementNetworkCode}}</p>
    <p>{{ 'reference-code-label' | translation | async }}{{referenceCode}}</p>
  </div>
  <br>
  <div class="step-container">
    <div class="step">
      <div class="step-number">1.</div>
      <div class="step-description">{{ 'cash-step-one' | translation | async }}</div>
    </div>
    <br>
    <div class="step">
      <div class="step-number">2.</div>
      <div class="step-description">{{ 'cash-step-two' | translation | async }}</div>
    </div>
  </div>
  <br>
  <div class="additional-note">
    <p class="additional-note-text" innerHTML="{{ 'remember-info' | translation | async }}"></p>
  </div>
</div>
